__webpack_require__.p = "https://ikea.marat.qd.je/dk/da/customer-service/support/";